import React, { memo } from 'react';
import { IoArrowForwardOutline } from 'react-icons/io5';
import { useFetchManLaboLatestSurveyAnswerTexts } from '../../../hooks/manzokudoLabo/useFetchManLaboLatestSurveyAnswerTexts';
import { LatestSurveyAnswerTextsLayout } from '../../template/LatestSurveyAnswerTextsLayout';
import { CardBody, CardHeader, Flex, HStack, Icon, Link, Skeleton, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

import { LightShadowCard } from '../../molecules/card/LightShadowCard';


type ManLaboLatestSurveyAnswerTextsCardProps = {
  restaurantId: string
}
export const ManLaboLatestSurveyAnswerTextsCard: React.FC<ManLaboLatestSurveyAnswerTextsCardProps> = memo(({restaurantId}) => {
  const { manLaboLatestSurveyAnswerTexts, isLoading } = useFetchManLaboLatestSurveyAnswerTexts(restaurantId)
  return (
    <Skeleton isLoaded={!isLoading} rounded='2xl'>
      <LightShadowCard >
        <CardHeader>
          <Flex align='center' justify='space-between'>
            <Text m={0} fontSize='lg' fontWeight='bold'>最新レビュー</Text>
            <Link as={RouterLink} to='../answer-texts' fontSize='sm' color='gray.500' fontWeight='bold' _hover={{ color: 'gray.400' }}>
              <HStack align='center' spacing={1}>
                <Text m='0'>詳細</Text>
                <IoArrowForwardOutline size="20px" />
              </HStack>
            </Link>
          </Flex>
        </CardHeader>
        <CardBody pt={0}>
          {manLaboLatestSurveyAnswerTexts && <LatestSurveyAnswerTextsLayout latestSurveyAnswerTexts={manLaboLatestSurveyAnswerTexts} />}
        </CardBody>
      </LightShadowCard>
    </Skeleton>
  );
});